"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberValidator = void 0;
const Validator_1 = require("../validator/Validator");
class NumberValidator extends Validator_1.Validator {
    static isNumber(value) {
        return typeof value === 'number';
    }
    static minimum(value, min) {
        return _a.isNumber(value) && value >= min;
    }
    static maximum(value, max) {
        return _a.isNumber(value) && value <= max;
    }
    static isEqualTo(value, equalTo) {
        return value === equalTo;
    }
    static isPositive(value) {
        return _a.isNumber(value) && value >= 0;
    }
    static isNegative(value) {
        return _a.isNumber(value) && value < 0;
    }
    static isEqualToZero(value) {
        return _a.isNumber(value) && value === 0;
    }
    static isInteger(value) {
        return _a.isNumber(value) && Number.isInteger(value);
    }
    static isDecimal(value) {
        return _a.isNumber(value) && !Number.isInteger(value);
    }
}
exports.NumberValidator = NumberValidator;
_a = NumberValidator;
NumberValidator.IS_NUMBER = () => _a.validatorFactory('IS_NUMBER', _a.isNumber);
NumberValidator.IS_POSITIVE = () => _a.validatorFactory('IS_POSITIVE', _a.isPositive);
NumberValidator.IS_NEGATIVE = () => _a.validatorFactory('IS_NEGATIVE', _a.isNegative);
NumberValidator.IS_ZERO = () => _a.validatorFactory('IS_ZERO', _a.isEqualToZero);
NumberValidator.IS_INTEGER = () => _a.validatorFactory('IS_INTEGER', _a.isInteger);
NumberValidator.IS_DECIMAL = () => _a.validatorFactory('IS_DECIMAL', _a.isDecimal);
NumberValidator.MIN = (min) => _a.validatorFactory('MIN', value => _a.minimum(value, min));
NumberValidator.MAX = (max) => _a.validatorFactory('MAX', value => _a.maximum(value, max));
NumberValidator.IS_EQUAL = (equalTo) => _a.validatorFactory('IS_EQUAL', value => _a.isEqualTo(value, equalTo));
//# sourceMappingURL=NumberValidator.js.map